import React, { FC, useCallback, useEffect, useState } from 'react'
import { STabList } from '@components/Questions/styled'
import QuestionsListItem from '@components/Questions/QuestionsListItem'
import { IQuestion, IQuestionsListProps } from '@components/Questions/types'

const QuestionsList: FC<IQuestionsListProps> = ({ data }) => {
  const [indexOfOpenedItem, setIndexOfOpenedItem] = useState<number | null>(null)

  useEffect(() => {
    setIndexOfOpenedItem(null)
  }, [data])

  const onClose = useCallback(() => {
    setIndexOfOpenedItem(null)
  }, [])

  const onOpen = useCallback((index: number) => {
    setIndexOfOpenedItem(index)
  }, [])

  return (
    <STabList>
      {data.map(({ title, content }: IQuestion, index) => (
        <QuestionsListItem
          key={index}
          index={index}
          title={title}
          content={content}
          isOpened={index === indexOfOpenedItem}
          onOpen={onOpen}
          onClose={onClose}
        />
      ))}
    </STabList>
  )
}

export default QuestionsList
